import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SPORTSCONTENT } from "../../constants/TextContainer";
import { filterDataContext } from "../../App";

const HomeImageContent = () => {
  const [sportData, setSportData] = useState([]);
  const { selectedSport } = useContext(filterDataContext);

  const setHomeImages = () => {
    let data = SPORTSCONTENT?.filter((item) => {
      return item.sport_type === selectedSport;
    });
    setSportData(data);
  };

  useEffect(() => {
    if (selectedSport) {
      setHomeImages();
    }
  }, [selectedSport]);

  return (
    <>
      {sportData.map((item, index) => {
        return (
          <section
            className="portal_image"
            style={{ backgroundImage: `url(${item.image})` }}
            key={index}
          >
            <div className="image_div">
              <div className="content_portal">
                <h1>Welcome to TRP Events</h1>
                <p>{item.text}</p>
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
};

export default HomeImageContent;
